export default __webpack_public_path__ + "cc8c46612bf47dd39849c3f5e68a3ae8.jpg";